/**
 * HomeBanner
 */
import React , {Component} from 'react';
import { Row, Col, Container } from 'reactstrap';
import {Link} from 'react-router-dom';

class HomeBanner extends Component {

   render() {
    return (
        <Row className="row section-pb">
            <Col md={6} className="mb-2 mb-sm-0">
            <div className="magasin_banner_wrapper mb-4 pb-2">
            <div className="magasin_banner magasin_banner-style-style-1 magasin_banner-effect-none">
                <img className="magasin_banner-image img-fluid inline" alt="Banner" src={require(`../assets/images/categories/default/adv-banner-img1.png`)}  />
                <div className="magasin_banner-content magasin_banner-content-1">
                    <div className="magasin_banner-content-wrapper">
                    <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-label-wrap gscore_banner-text-wrap-1 magasin_banner-text-bg_color hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-label"> New</div>
                        </div>
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-2 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text"><h2> Checked Blouse With Ruffle Trims</h2></div>
                        </div>
                        <div className="magasin_banner-btn-wrap magasin_banner-btn-style-link magasin_banner-btn-shape-square"> <Link to="/shop" className="magasin_banner-btn inline_hover">Shop Now</Link></div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
            <div className="magasin_banner_wrapper">
            <div className="magasin_banner magasin_banner-style-style-1 magasin_banner-effect-none">
                <img className="magasin_banner-image img-fluid inline img-fluid" alt="Banner" src={require(`../assets/images/categories/default/adv-banner-img3.png`)} />
                <div className="magasin_banner-content magasin_banner-content-2">
                    <div className="magasin_banner-content-wrapper">
                    <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-label-wrap magasin_banner-text-wrap-1 magasin_banner-text-bg_color hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-label magasin_banner-lanel-yellow"> Sale</div>
                        </div>
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-2 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text"><h2> trousers with contrasting topstitching</h2></div>
                        </div>
                        <div className="magasin_banner-btn-wrap magasin_banner-btn-style-link magasin_banner-btn-shape-square justify-content-end"> <Link to="/shop" className="magasin_banner-btn inline_hover">Shop Now</Link></div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
            </Col>
            <Col md={6} className="mt-4 mt-md-0">
            <div className="magasin_banner_wrapper" style={{backgroundImage: 'url(categories/default/adv-banner-img2.png)'}}>
            <div className="magasin_banner magasin_banner-3 magasin_banner-style-style-1 magasin_banner-effect-none">
                <img className="magasin_banner-image img-fluid inline" alt="Banner" src={require(`../assets/images/categories/default/adv-banner-img2.png`)} />
                <div className="magasin_banner-content position-md-r magasin_banner-content-hleft magasin_banner-content-vtop">
                    <div className="magasin_banner-content-wrapper">
                    <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-1 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text">
                        <h2 className="mt-sm-0">Tops</h2>
                        </div>
                        </div>
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-2 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text">
                        <h3>Season festival</h3>
                        </div>
                        </div>
                        <div className="magasin_banner-btn-wrap magasin_banner-btn-style-flat magasin_banner-btn-size-md magasin_banner-btn-shape-square"> <Link to="/shop" className="magasin_banner-btn">Buy now!</Link></div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
            </Col>
        </Row>

      )
   }
}

export default HomeBanner;
